const translations = {
    fr: {
      loading: "Chargement des statistiques...",
      villageHistoryTitle: "Historique des villages explorés",
      noParcoursAvailable: "Aucun parcours disponible.",
      progressionLabel: "Progression",
      completedParcoursLabel: "Parcours terminé",
      partnerHistoryTitle: "Historique des parties effectuées chez nos partenaires",
      noPartnerData: "Aucune donnée n'est encore disponible.",
      unknownVillage: "Village"
    },
    en: {
      loading: "Loading statistics...",
      villageHistoryTitle: "History of explored villages",
      noParcoursAvailable: "No parcours available.",
      progressionLabel: "Progress",
      completedParcoursLabel: "Parcours completed",
      partnerHistoryTitle: "History of games with our partners",
      noPartnerData: "No data available yet.",
      unknownVillage: "Village"
    },
    de: {
      loading: "Statistiken werden geladen...",
      villageHistoryTitle: "Verlauf der erkundeten Dörfer",
      noParcoursAvailable: "Keine Parcours verfügbar.",
      progressionLabel: "Fortschritt",
      completedParcoursLabel: "Parcours abgeschlossen",
      partnerHistoryTitle: "Verlauf der Spiele bei unseren Partnern",
      noPartnerData: "Noch keine Daten verfügbar.",
      unknownVillage: "Dorf"
    },
    es: {
      loading: "Cargando estadísticas...",
      villageHistoryTitle: "Historial de pueblos explorados",
      noParcoursAvailable: "Ningún recorrido disponible.",
      progressionLabel: "Progreso",
      completedParcoursLabel: "Recorrido completado",
      partnerHistoryTitle: "Historial de juegos con nuestros socios",
      noPartnerData: "Aún no hay datos disponibles.",
      unknownVillage: "Pueblo"
    },
    it: {
      loading: "Caricamento delle statistiche...",
      villageHistoryTitle: "Cronologia dei villaggi esplorati",
      noParcoursAvailable: "Nessun percorso disponibile.",
      progressionLabel: "Progressione",
      completedParcoursLabel: "Percorso completato",
      partnerHistoryTitle: "Cronologia delle partite con i nostri partner",
      noPartnerData: "Nessun dato disponibile al momento.",
      unknownVillage: "Villaggio"
    }
  };
  
  export default translations;
  